import React from 'react';
import VERSION from '../version';

/**
 * Version component that displays the current application version
 * Combines semver from package.json with git commit SHA
 *
 * @param {Object} props - Component props
 * @param {Object} props.style - Additional CSS styles to apply
 * @returns {JSX.Element} Version display component
 */
const Version = ({ style = {} }) => {
  const defaultStyle = {
    color: '#888',
    fontSize: '12px',
    textAlign: 'center',
    marginTop: '5px'
  };

  const combinedStyle = {
    ...defaultStyle,
    ...style
  };

  return (
    <div style={combinedStyle}>
      version {VERSION}
    </div>
  );
};

export default Version;